import { useBlockSupportStore } from '@components/Settings/BlockSupport/BlockSupportStore';
import { useEffect, useState } from '@wordpress/element';

export const useDynamicBlockSupportHook = (blockname: string) => {
  const { dynamic, allowed_dynamic } = useBlockSupportStore();

  const [blockSupport, setBlocksupport] = useState({
    is_allowed: false,
    is_dynamic: false,
  });

  useEffect(() => {
    const isAllowed = allowed_dynamic === null ? [] : allowed_dynamic;
    const isDynamic = dynamic === null ? [] : dynamic;

    setBlocksupport({
      is_allowed: isAllowed.includes(blockname),
      is_dynamic: isDynamic.includes(blockname),
    });
  }, [dynamic, allowed_dynamic, blockname]);

  return blockSupport;
};

export default {
  useDynamicBlockSupportHook,
};
